import { render, staticRenderFns } from "./VideoLoop.global.vue?vue&type=template&id=58fca33d&scoped=true&"
import script from "./VideoLoop.global.vue?vue&type=script&lang=js&"
export * from "./VideoLoop.global.vue?vue&type=script&lang=js&"
import style0 from "./VideoLoop.global.vue?vue&type=style&index=0&id=58fca33d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fca33d",
  null
  
)

export default component.exports